import React from 'react';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import parts from '../moduleCard/moduleParts.module.css';
import styles from './scales.module.css';
import { hasOptionImage, resolveOptionImage } from '../../modules/scales/scaleImages';

/** Agrupa opções consecutivas com o mesmo `group` (faixas como "Hidratado"). */
function groupOptions(options) {
  const groups = [];
  options.forEach((option) => {
    const last = groups[groups.length - 1];
    if (last && last.label === (option.group || null)) last.options.push(option);
    else groups.push({ label: option.group || null, options: [option] });
  });
  return groups;
}

const OptionCard = ({ option, selected, readOnly, gender, onClick }) => {
  const image = resolveOptionImage(option, gender);
  const className = [
    styles.option,
    selected ? styles.optionSelected : '',
    readOnly ? styles.optionReadOnly : '',
  ].join(' ');

  return (
    <Tooltip title={option.help || ''} placement="top" arrow enterTouchDelay={400} disableHoverListener={!option.help}>
      <button
        type="button"
        className={className}
        aria-pressed={selected}
        aria-disabled={readOnly || undefined}
        onClick={readOnly ? undefined : () => onClick(option.value)}
      >
        {option.color && <span className={styles.swatch} style={{ background: option.color }} />}
        {image && <img className={styles.image} src={image} alt="" draggable={false} />}
        <span className={styles.optionLabel}>{option.label}</span>
        {option.caption && <span className={styles.optionCaption}>{option.caption}</span>}
        {selected && <span className={styles.check}><CheckCircleIcon /></span>}
      </button>
    </Tooltip>
  );
};

/**
 * Cards grandes das opções de uma escala: um clique escolhe, com destaque
 * azul; a ajuda de cada opção aparece no tooltip. Serve a escolha única,
 * múltipla e cada uma das respostas do tipo dual.
 *
 * `selected`: lista de valores marcados; `onToggle(value)`; `readOnly` para a prévia.
 */
const ScaleOptionGrid = ({ options, selected, onToggle, readOnly = false, gender }) => {
  const list = Array.isArray(options) ? options : [];
  const withImages = list.some(hasOptionImage);
  const marked = new Set(selected || []);

  return groupOptions(list).map((group, index) => (
    <div key={group.label || index} className={styles.group}>
      {group.label && <span className={parts.sectionLabel}>{group.label}</span>}
      <div className={`${styles.grid} ${withImages ? styles.gridImages : ''}`}>
        {group.options.map((option) => (
          <OptionCard
            key={option.value}
            option={option}
            selected={marked.has(option.value)}
            readOnly={readOnly}
            gender={gender}
            onClick={onToggle}
          />
        ))}
      </div>
    </div>
  ));
};

export default ScaleOptionGrid;
